import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Services from '../pages/Services';
import Contact from '../pages/Contact';
import Invoice from '../components/Invoice';
import AdminChat from '../Admin/AdminChat';
import Feedback from '../components/Feedback';
import About from '../pages/About';
import Policy from '../policys/Policy';
import Terms from '../policys/Terms';
import Location from '../components/Location';

export default function PageNavigation() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/choose-location" element={<Location />} />
			<Route path="/service" element={<Services />} />
			<Route path="/contact-us" element={<Contact />} />
			<Route path="/feedback" element={<Feedback />} />
			<Route path="/about-us" element={<About />} />
			<Route path="/privacy-policy" element={<Policy />} />
			<Route path="/terms-and-conditions" element={<Terms />} />
			<Route
				path="/hometch/repairs/my/personal/AdminChat"
				element={<AdminChat />}
			/>
			<Route path="/invoice/:orderNumber" element={<Invoice />} />

			{/* Catch-all route to redirect unknown paths to home */}
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}
